import { Row } from "react-bootstrap";
import { DesktopPlaceholder } from "@assets/images/svg/desktopPlaceholder";

function HomeLeftColumn() {
  const screenWidth = "100%";
  const screenHeigth = "auto";
  
  return (
    <Row>
      <div className="left-column">
        <DesktopPlaceholder width={screenWidth} height={screenHeigth} />
      </div>
    </Row>
  );
}

export default HomeLeftColumn;
